import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ApiResponse } from 'src/app/shared/models/api-response.interface';
import {
  DealerNoteResponse,
  Note,
  NoteResponse,
} from '../../../shared/models/note.model';

@Injectable({
  providedIn: 'root',
})
export class NotesApiService {
  private entityUrl: string = '/note';

  constructor(private apiService: HttpService) {}

  getAll(payload: {
    model: string;
    model_id: string | number;
    is_claim_note?: boolean;
    starred?: boolean;
    filter_by_dealer?: number;
    is_agent_note?: boolean;
  }): Observable<ApiResponse<NoteResponse[]>> {
    return this.apiService.postReq(`${this.entityUrl}/list`, payload);
  }

  getAllDealerNotes(payload: {
    model: string;
    model_id: string | number;
    dealer_note: boolean;
  }): Observable<ApiResponse<DealerNoteResponse[]>> {
    return this.apiService.postReq(`${this.entityUrl}/list`, payload);
  }

  getDealerClaimsNotes(
    model_id: number
  ): Observable<ApiResponse<NoteResponse[]>> {
    const params = {
      model: 'user',
      model_id,
      is_claim_note: true,
    };
    return this.apiService.postReq(`${this.entityUrl}/list`, params);
  }

  create(note: Note): Observable<ApiResponse> {
    return this.apiService.postReq(this.entityUrl, note);
  }

  delete(id: number): Observable<ApiResponse> {
    return this.apiService.deleteReq(`${this.entityUrl}/${id}`);
  }

  update(id: number, note: Note): Observable<ApiResponse> {
    return this.apiService.putReq(`${this.entityUrl}/${id}`, note);
  }

  setStar(
    id: number,
    payload: { starred?: boolean; star_reason?: string | null } = {}
  ): Observable<ApiResponse<NoteResponse>> {
    return this.apiService.postReq(`${this.entityUrl}/${id}/star`, payload);
  }
}
